<template>
  <b-dropdown class="list-dropdown" ref="dropdown" variant="link" :size="size" block no-caret :disabled="disabled" menu-class="shadow-sm overflow-visible min-width" @hide="onDropdownHide">
    <template #button-content>
      <div class="custom-select text-left">
        <span v-if="!busy" :title="selected ? selected.name : ''" class="selected">
          <i v-if="selected" :class="`fa fa-fw fa-${selected.has_form || selected.has_new_form ? 'file' : 'list'}`"></i>
          {{ selected ? `${selected.name} (${selected.count})` : placeholder }}
        </span>
        <span v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </span>
      </div>
    </template>
    <b-dropdown-text>
      <b-row>
        <b-col v-if="limitSelectionIds && limitSelectionIds.length > 0" class="col-auto pb-2">
          <b-button variant="outline-secondary" size="sm" class="bg-light text-muted" @click="onToggleUnlockLimit" :title="trans('limited_selection_about')" v-b-tooltip.hover>
            <i :class="`fa fa-fw fa-lock${unlock_limit ? '-open' : ''}`"></i>
          </b-button>
        </b-col>
        <b-col v-if="!mode" class="pb-2">
          <b-form-radio-group buttons button-variant="outline-primary" size="sm" v-model="search_mode" :options="searchModeOptions" :disabled="busy" @change="onChangeSearchMode" />
        </b-col>
        <b-col :class="`${!!mode ? '' : 'col-auto'} pl-0 text-right`">
          <b-button style="background: none; border: 0" variant="light" size="sm" class="px-1 text-muted" @click="onClear" :title="trans('clear')" v-b-tooltip.hover>
            <i :class="`fa fa-fw fa-times`"></i>
          </b-button>
          <b-button style="background: none; border: 0" variant="light" size="sm" class="px-1 text-muted" @click="fetch" :title="trans('refresh')" v-b-tooltip.hover>
            <i class="fa fa-fw fa-redo" v-if="!busy"></i>
            <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
          </b-button>
          <b-button :variant="pinned ? 'primary' : 'link'" size="sm" :class="pinned ? 'px-1' : 'px-1 text-muted'" :title="trans('pinned')" @click="pinned = !pinned">
            <i class="fa fa-fw fa-thumbtack"></i>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col class="pr-1">
          <b-form-input ref="search" type="search" v-model="search" size="sm" :debounce="500" :placeholder="trans('search')" :disabled="busy" />
        </b-col>
        <b-col class="pl-1">
          <tags-filter
            :organization="organization"
            :type="tagType"
            v-model="tag"
            right
            boundary="body"
            @input="onTagChange"
            @show="onTagsShow"
            @hidden="onTagsHidden"
          ></tags-filter>
        </b-col>
      </b-row>
    </b-dropdown-text>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-text v-if="!!error" variant="danger">
      {{ error }}
    </b-dropdown-text>
    <b-dropdown-text v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </b-dropdown-text>
    <b-dropdown-text v-if="!busy && items && items.length == 0">
      <em>{{ trans('no_result') }}</em>
    </b-dropdown-text>
    <b-dropdown-item v-for="item in items" v-bind:key="item.id" :active="item.id == value" :disabled="disabled || busy" @click="onClickItem(item)">
      <b-row>
        <b-col class="col-auto px-0">
          <i :class="`fa fa-fw fa-${item.has_form || item.has_new_form ? 'file-alt' : 'list'}`"></i>
        </b-col>
        <b-col class="pl-1 pr-0">
          <span>{{ item.name }} ({{ item.count }})</span>
          <small class="text-muted">{{ trans('list_type_' + (item.is_registration_form ? 'registration_form' : (item.is_marketing_form ? 'marketing' : (item.subtype || item.type)))) }}</small>
          <tags
            :organization="organization"
            :model="item"
            inline
            :type="tagType"
            hide-edit
          ></tags>
        </b-col>
      </b-row>
    </b-dropdown-item>
    <b-dropdown-divider v-if="mode != 'forms' && !type && !!builtin"></b-dropdown-divider>
    <b-dropdown-item
      v-if="mode != 'forms' && !type && !!builtin"
      v-for="l in builtin" :key="l.id"
      :active="l.id == value"
      :disabled="disabled || busy"
      @click="onClickItem(l)"
    >
      <i :class="`fa fa-fw fa-${l.type == 'all_clients' ? 'users' : 'chalkboard-teacher'}`"></i>
      <span>{{ trans('list_type_'+l.type) }} ({{ l.count }})</span>
    </b-dropdown-item>
    <b-dropdown-divider v-if="mode != 'forms' && !!builtin && builtin.length > 0"></b-dropdown-divider>
    <b-dropdown-text>
      <b-row>
        <b-col class="text-center">
          <b-button variant="link" class="p-0" :disabled="disabled || busy || page == 1" @click="onPreviousPage">
            <i class="fa fa-fw fa-chevron-left"></i>
          </b-button>
        </b-col>
        <b-col v-if="nullable" class="text-center">
          <b-button variant="link" class="p-0 text-danger" :disabled="disabled || busy || !value" :title="trans('clear')" v-b-tooltip.hover @click="onClear">
            <i class="fa fa-fw fa-times"></i>
          </b-button>
        </b-col>
        <b-col class="text-center">
          <b-button variant="link" class="p-0" :disabled="disabled || busy || page == last_page" @click="onNextPage">
            <i class="fa fa-fw fa-chevron-right"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-dropdown-text>
  </b-dropdown>
</template>

<style>
  .list-dropdown.b-dropdown>button {
    padding: 0;
  }
  .list-dropdown.b-dropdown>.dropdown-menu {
    max-width: 100%;
  }
  .list-dropdown.b-dropdown>.dropdown-menu .dropdown-item {
    white-space: normal;
  }
</style>

<script>
  import Tags from './../tag/Tags'
  import TagsFilter from './../tag/TagsFilter'
  import Treeselect from '@riophae/vue-treeselect'

  export default {
    props: {
      organization: Object,
      value: {
        type: Number,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      nullable: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: trans('choose_a_list'),
      },
      mode: {
        type: String,
        default: null, // lists, forms or null for both
      },
      showClasses: {
        type: Boolean,
        default: false,
      },
      noMaster: {
        type: Boolean,
        default: false,
      },
      noClassParticipants: {
        type: Boolean,
        default: false,
      },
      initial_page_url: String,
      type: {
        type: String,
        default: null, // published, waivers, csv
      },
      limitSelectionIds: Array,
      forSequence: Object,
      onlyWithInvoiceContributions: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Tags,
      TagsFilter,
      Treeselect,
    },
    data() {
      return {
        trans: trans,
        numeral: numeral,
        busy: false,
        error: null,
        items: null,
        search: null,
        search_mode: this.showClasses ? 'classes' : 'lists', // lists or forms
        searchModeOptions: _.compact([{
          text: trans('lists'),
          value: 'lists'
        }, {
          text: trans('forms'),
          value: 'forms',
        }, this.showClasses ? {
          text: trans('classes'),
          value: 'classes',
        } : null]),
        tag: null,
        tags_filter_opened: false,
        pinned: false,
        selected: null,
        builtin: null,
        total: null,
        page: 1,
        last_page: 1,
        per_page: 10,
        unlock_limit: false,
      }
    },
    computed: {
      initial_upid() {
        return this.initial_page_url ? this.initial_page_url.split('/').pop() : null
      },
      tagType() {
        if (this.search_mode == 'classes') return 'class'
        if (this.search_mode == 'forms') return 'form'
        return 'list'
      },
    },
    watch: {
      search() {
        this.page = 1
        this.fetch().then(() => {
          this.$refs.search.focus()
        })
      },
      pinned() {
        this.page = 1
        this.fetch()
      },
      value() {
        // this.selected = _.find(this.items, {id: this.value})
        this.fetch()
      }
    },
   	methods: {
      onDropdownHide(e) {
        if (this.tags_filter_opened) e.preventDefault()
      },
      onTagsShow() {
        this.tags_filter_opened = true
      },
      onTagsHidden() {
        this.tags_filter_opened = false
      },
      onTagChange() {
        this.page = 1
        this.fetch()
      },
      onChangeSearchMode() {
        this.page = 1
        this.fetch()
      },
      onToggleUnlockLimit() {
        this.unlock_limit = !this.unlock_limit
        this.page = 1
        this.fetch()
      },
      onClear() {
        this.selected = null
        this.$emit('input', null)
        this.$emit('list', null)
        this.$refs.dropdown.hide(true)
      },
      onPreviousPage(bvEvt) {
        if (this.page <= 1) return
        this.page -= 1
        this.fetch()
      },
      onNextPage(bvEvt) {
        if (this.page >= this.last_page) return
        this.page += 1
        this.fetch()
      },
      onClickItem(item) {
        this.selected = item
        this.$emit('input', item.id)
        this.$emit('list', item, {source: 'user'})
      },
      prefetchSelected() {
        if (!this.value) {
          this.selected = null
          return new Promise((resolve, reject) => {
            resolve({data: null})
          })
        }
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/list/${this.value}/get`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.selected = response.data
          if (['am_class', 'amilia_activity'].indexOf(this.selected.type) >= 0 && this.showClasses) {
            this.search_mode = 'classes'
          }
          else if (this.selected.type.indexOf('form') >= 0 && !this.mode || this.mode == 'forms') {
            this.search_mode = 'forms'
          }
          else if (!this.mode || this.mode == 'lists') {
            this.search_mode = 'lists'
          }
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
   	  fetch(firstTime) {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/list/list?per_page=${this.per_page}&page=${this.page}&no_meta=true`
        if (this.value) url += `&selected=${this.value}`
        else if (firstTime && this.initial_upid) url += `&selected_upid=${this.initial_upid}`
        if (this.mode != null) url += `&mode=${this.mode}`
        else url += `&mode=${this.search_mode}`
        if (this.type) url += `&type=${this.type}`
        if (this.tag) url += `&tag=${encodeURIComponent(this.tag)}`
        if (this.noMaster) url += `&no-master`
        if (this.noClassParticipants) url += '&no-class-participants'
        if (this.search) url += `&list=${encodeURIComponent(this.search)}`
        if (this.tag) url += `&tag=${encodeURIComponent(this.tag)}`
        if (this.pinned) url += `&pinned=true`
        if (this.limitSelectionIds && this.limitSelectionIds.length > 0 && !this.unlock_limit)
          url += `&limit_selection_ids=${this.limitSelectionIds.join(',')}`
        if (this.forSequence !== undefined) {
          url += '&for_sequence'
          if (!!this.forSequence) url += '=' + this.forSequence.id
        }
        if (this.onlyWithInvoiceContributions) url += '&only_with_invoice_contributions=true'
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.total = response.data.total
          this.page = response.data.current_page
          this.last_page = response.data.last_page
          this.items = response.data.data
          if (response.data.selected) {
            if (this.value != response.data.selected.id) this.$emit('input', response.data.selected.id)
            this.selected = response.data.selected
          }
          this.builtin = response.data.builtin
          this.$emit('loaded')
          if (this.selected) this.$emit('list', this.selected, {source: 'fetch'})
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
   	  },
   	},
   	mounted() {
      window.listDropdown = this
      this.prefetchSelected().then(() => {
        this.fetch(true)        
      })
   	},
  }
</script>